import { render, staticRenderFns } from "./categoriasAdd.vue?vue&type=template&id=23f10e92"
import script from "./categoriasAdd.vue?vue&type=script&lang=js"
export * from "./categoriasAdd.vue?vue&type=script&lang=js"
import style0 from "./categoriasAdd.vue?vue&type=style&index=0&id=23f10e92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports